/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonspreviewlabel3Inputs */

const en_listingbuttonspreviewlabel3 = /** @type {(inputs: Listingbuttonspreviewlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview of the page in the app`)
};

const de_listingbuttonspreviewlabel3 = /** @type {(inputs: Listingbuttonspreviewlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau der Seite in der App`)
};

/**
* | output |
* | --- |
* | "Preview of the page in the app" |
*
* @param {Listingbuttonspreviewlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonspreviewlabel3 = /** @type {((inputs?: Listingbuttonspreviewlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonspreviewlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonspreviewlabel3(inputs)
	return de_listingbuttonspreviewlabel3(inputs)
});
export { listingbuttonspreviewlabel3 as "listingButtonsPreviewLabel" }